// ----------------------------
// Created by Bulletproof Games
//            2018
//  www.bulletproofgames.co.uk
// ----------------------------

winlineFadeAnimator = {};
winlineFadeAnimator.SEGMENT_ANIM_TIME = 50;
winlineFadeAnimator.WIDTH_OF_MASK = 710;

winlineFadeAnimator.initialise = function () {
  winlineFadeAnimator.startSprites = [];
  winlineFadeAnimator.joinSprites = [];
  winlineFadeAnimator.endSprites = [];

  const mask1 = winlineFadeAnimator.createMask();
  const mask2 = winlineFadeAnimator.createMask();
  const winlineContainer = resourceManager.get('slotContainer:winlinesContainer');
  winlineContainer.addChild(mask1);
  winlineContainer.mask = mask1;

  const maskedContainer = resourceManager.get('slotContainer:winlinesContainer:maskedContainer');
  maskedContainer.addChild(mask2);
  maskedContainer.mask = mask2;

  // Hide all winlines
  // 5 is number of rows
  for (var i = 0; i < 5; i++) {
    winlineFadeAnimator.startSprites.push(
      resourceManager.get('slotContainer:winlinesContainer:maskedContainer:start:' + i)
    );
    winlineFadeAnimator.startSprites[i].visible = false;

    winlineFadeAnimator.endSprites.push(
      resourceManager.get('slotContainer:winlinesContainer:maskedContainer:end:' + i)
    );
    winlineFadeAnimator.endSprites[i].visible = false;
  }

  // 4 and 15 mean what?!?!
  // 15 seems to be from the winlines.json
  // and the 4 is the number of joins required
  for (var i = 0; i < 4; i++) {
    winlineFadeAnimator.joinSprites.push([]);
    for (var j = 0; j < 15; j++) {
      winlineFadeAnimator.joinSprites[i].push(
        resourceManager.get('slotContainer:winlinesContainer:maskedContainer:join' + i + ':winlineParts:' + j)
      );
      winlineFadeAnimator.joinSprites[i][j].visible = false;
    }
  }
};

winlineFadeAnimator.createMask = function () {
  const width = winlineFadeAnimator.WIDTH_OF_MASK;
  const height = 730;

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');

  // left → right gradient
  const gradient = ctx.createLinearGradient(0, 0, width, 0);

  gradient.addColorStop(0, 'rgba(255,0,0,0)'); // fade in
  gradient.addColorStop(0.025, 'rgba(255,0,0,1)'); // solid
  gradient.addColorStop(0.975, 'rgba(255,0,0,1)'); // solid
  gradient.addColorStop(1, 'rgba(255,0,0,0)'); // fade out

  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, width, height);

  const texture = PIXI.Texture.fromCanvas(canvas);
  const maskSprite = new PIXI.Sprite(texture);
  maskSprite.anchor.set(0.5, 0);
  maskSprite.x = 314;
  maskSprite.y = -66;
  return maskSprite;
};

winlineFadeAnimator.playAnimation = function (sequence, callback, maxTime) {
  // callback();
  // return;

  soundManager.play('winline');
  winlineFadeAnimator.completeCallback = callback;
  winlineFadeAnimator.sequence = sequence;
  winlineFadeAnimator.maxTime = maxTime;

  if (checkForUndefined(winlineFadeAnimator.maxTime)) {
    winlineFadeAnimator.maxTime = 999999999;
  }

  if (checkForUndefined(sequence.sound, 'No sound was defined for sequence', true)) return;
  winlineFadeAnimator.soundFinished = false;
  soundManager.play(sequence.sound, winlineFadeAnimator.onSoundFinished);

  winlineFadeAnimator.spritesToAnimate = [];
  // Setup winlines to fade in
  const paylines = sequence.paylineData;
  for (let p = 0; p < paylines.length; p++) {
    winlineFadeAnimator.spritesToAnimate[p] = [];
    // whats the 2 all about? speak to stu if he remembers
    winlineFadeAnimator.spritesToAnimate[p].push(winlineFadeAnimator.startSprites[paylines[p][0].row]);

    for (let i = 0; i < paylines[p].length - 1; i++) {
      const reel = paylines[p][i].reel;
      const spriteID = paylines[p][i].row * 2 + paylines[p][i + 1].row;
      winlineFadeAnimator.spritesToAnimate[p].push(winlineFadeAnimator.joinSprites[reel][spriteID]);
    }

    winlineFadeAnimator.spritesToAnimate[p].push(
      winlineFadeAnimator.endSprites[paylines[p][paylines[p].length - 1].row]
    );
  }

  for (let p = 0; p < winlineFadeAnimator.spritesToAnimate.length; p++) {
    for (let i = 0; i < winlineFadeAnimator.spritesToAnimate[p].length; i++) {
      winlineFadeAnimator.spritesToAnimate[p][i].visible = true;
      winlineFadeAnimator.spritesToAnimate[p][i].alpha = 1;
    }
  }

  const winlineContainer = resourceManager.get('slotContainer:winlinesContainer');
  winlineContainer.mask.alpha = 1;
  winlineContainer.mask.x = 314 - winlineFadeAnimator.WIDTH_OF_MASK;
  // winlineFadeAnimator.maskFadeIn = gsap.fromTo(
  //   winlineContainer.mask,
  //   {
  //     alpha: 0,
  //   },
  //   {
  //     alpha: 1,
  //     duration: 0.25,
  //   }
  // );
  winlineFadeAnimator.maskMoveIn = gsap.fromTo(
    winlineContainer.mask,
    {
      x: 314 - winlineFadeAnimator.WIDTH_OF_MASK,
    },
    {
      x: 314,
      duration: 0.75,
      ease: 'power2.out',
    }
  );

  winlineFadeAnimator.waitForRemovalTimer = timerManager.addTimeout(900, () => {
    winlineFadeAnimator.waitForRemovalTimer = null;
    winlineFadeAnimator.maskFadeOut = gsap.fromTo(
      winlineContainer.mask,
      {
        alpha: 1,
      },
      {
        alpha: 0,
        ease: 'none',
        duration: 0.75,
        onComplete: () => {
          winlineFadeAnimator.animationComplete();
          callback();
        },
      }
    );
    // winlineFadeAnimator.maskMoveOut = gsap.fromTo(
    //   winlineContainer.mask,
    //   {
    //     x: -117,
    //   },
    //   {
    //     x: 967,
    //     duration: 0.75,
    //     ease: 'power1.out',
    //     onComplete: () => {
    //       winlineFadeAnimator.animationComplete();
    //     },
    //   }
    // );
  });

  // winlineFadeAnimator.fadingIn = true;
  // winlineFadeAnimator.currentSegment = 0;
  // winlineFadeAnimator.segmentTimeRemaining = winlineFadeAnimator.SEGMENT_ANIM_TIME;

  // Reflex.addToUpdate(winlineFadeAnimator.update);
};

winlineFadeAnimator.onSoundFinished = function () {
  winlineFadeAnimator.soundFinished = true;
};

winlineFadeAnimator.skipAnimation = function () {
  soundManager.stop(winlineFadeAnimator.sequence.sound);
  winlineFadeAnimator.animationComplete();
  winlineFadeAnimator.completeCallback();
};

winlineFadeAnimator.animationComplete = function () {
  // Reset all winlines to default state
  for (let p = 0; p < winlineFadeAnimator.spritesToAnimate.length; p++) {
    for (let i = 0; i < winlineFadeAnimator.spritesToAnimate[p].length; i++) {
      winlineFadeAnimator.spritesToAnimate[p][i].visible = false;
      winlineFadeAnimator.spritesToAnimate[p][i].alpha = 1;
    }
  }

  winlineFadeAnimator.spritesToAnimate = [];

  if (winlineFadeAnimator.maskMoveIn) {
    winlineFadeAnimator.maskMoveIn.kill();
  }
  winlineFadeAnimator.maskMoveIn = null;

  if (winlineFadeAnimator.maskMoveOut) {
    winlineFadeAnimator.maskMoveOut.kill();
  }
  winlineFadeAnimator.maskMoveOut = null;

  if (winlineFadeAnimator.maskFadeOut) {
    winlineFadeAnimator.maskFadeOut.kill();
  }
  winlineFadeAnimator.maskFadeOut = null;

  if (winlineFadeAnimator.waitForRemovalTimer) {
    timerManager.stop(winlineFadeAnimator.waitForRemovalTimer);
  }
  winlineFadeAnimator.waitForRemovalTimer = null;
};

resourceManager.registerPlugIn('winlineFadeAnimator', winlineFadeAnimator);
